import { clearSession, getToken } from '@/lib/token'

export class ApiError extends Error {
  status: number
  body: unknown
  constructor(status: number, body: unknown, message: string) {
    super(message)
    this.status = status
    this.body = body
  }
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getToken()
  const headers = new Headers(init.headers)
  if (!headers.has('Content-Type') && init.body) headers.set('Content-Type', 'application/json')
  headers.set('Accept', 'application/json')
  if (token) headers.set('Authorization', `Bearer ${token}`)
  const resp = await fetch(path, { ...init, headers })
  if (resp.status === 401) {
    clearSession()
    if (!path.startsWith('/auth/')) {
      window.location.href = '/login'
    }
  }
  const text = await resp.text()
  const body = text ? JSON.parse(text) : null
  if (!resp.ok) {
    throw new ApiError(resp.status, body, (body && (body.detail || body.message)) || resp.statusText)
  }
  return body as T
}
